// /*  Setting services */
import { API } from '../../Services/Api';

const request = new API();

export const getLanguagesList = () => request.api.get(`/user/get-language/`);

export const getNotificationsList = () =>
  request.api.get(`/user/notifications/`);

export const changeNotificationsList = ({ push, email }) =>
  request.api.put(`/user/notifications/`, { push, email });

export const getSubscriptionsList = (filter) =>
  request.api.get(`subscription/${filter}/`);

export const cancelSubscription = (id) =>
  request.api.post(`/payments/subscription/change`, {force: false, plan: null});

export const cancelScheduling = (id) =>
  request.api.delete(`/payments/subscription/change`);

export const addCompanyDetails = (data) =>
  request.api.put(`user/update/`, { company: data });

export const changeBillingAddress = (data) =>
  request.api.put(`user/update/`, { billing_info: data });

export const getPayments = () => request.api.get(`payments/invoices/`);
export const changePayments = (data) => request.api.post(`payments/create_card`, data);

export const getPaymentsNext = ({ link }) => {
  const uri = new URL(link);
  uri.protocol = 'https://';
  return request.api.get(uri.toString(), null);
};

export const getPaymentDetails = ({ id }) => request.api.get(`payments/invoices/${id}/`);

export const getUserCountry = () => request.api.get(`user/get_country/`);
